module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Maasai-Web-1280.d4955972.jpg";